import React, { useEffect, useRef, useState } from 'react';
import IDHelpers from '../../../../core/helpers/IDHelper';
import TextHelper from '../../../../core/helpers/TextHelper';
import { Button, Titles } from '../../common/TabsStyled';
import { DateNavigator } from '../../../reusables/DateNavigator';
import { useWindowSize } from '@/core/hooks/useWindowSize';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

interface NavigationProps {
  tabs: any[];
  courseIdState: string;
  toggleTab: (id: string) => void;
  subscriptions?: number;
  selectIndex: (courseId: number) => void;
  courseIndex: number;
  setIsFirstTabActive: (isActive: boolean) => void;
}

const Navigation = (props: NavigationProps) => {
  const {
    tabs,
    courseIdState,
    toggleTab,
    subscriptions,
    selectIndex,
    courseIndex,
    setIsFirstTabActive
  } = props;
  const [loadingScroll, setLoadingScroll] = useState(true);
  const [showLeft, setShowLeft] = useState(false);
  const [showLeftArrow, setshowLeftArrow] = useState<boolean>(false);
  const { width } = useWindowSize();
  const scrollContainer: React.MutableRefObject<any> = useRef(null);
  const containerRef: React.MutableRefObject<any> = useRef(null);

  const setScrollToLeft = () => {
    containerRef.current.scrollLeft =
      sessionStorage.getItem('scrollXReinforcementNavigation') ?? 500;
  };

  useEffect(() => {
    setLoadingScroll(false);
    setScrollToLeft();
  }, [loadingScroll]);

  useEffect(() => {
    const firstTab = tabs[0]?.id;
    setIsFirstTabActive(courseIdState === firstTab);
  }, [courseIdState, tabs, setIsFirstTabActive]);

  const handleScroll = (event: any) => {
    sessionStorage.setItem(
      'scrollXReinforcementNavigation',
      event.currentTarget.scrollLeft
    );
  };

  const widthToDiv = (): number => {
    const contenedor = scrollContainer.current;
    let valueWidth = 0;

    if (contenedor) {
      const hijos = contenedor.children;

      for (let i = 0; i < hijos.length; i++) {
        valueWidth += Number(hijos[i].getBoundingClientRect().width);
      }
    }

    return valueWidth || 0;
  };

  useEffect(() => {
    const activeElement = scrollContainer.current.querySelector('.active');

    if (scrollContainer.current) {
      if (activeElement) {
        const containerWidth = scrollContainer.current.clientWidth;
        const elementWidth = activeElement.clientWidth;
        const elementOffsetLeft = activeElement.offsetLeft;

        const scrollTo =
          elementOffsetLeft - (containerWidth - elementWidth) / 2;
        if (scrollContainer?.current?.scrollTo)
          scrollContainer?.current?.scrollTo({
            left: scrollTo
          });
      }
    }
  }, [loadingScroll]);

  const validateArrowRight = () => {
    if (widthToDiv() === 0) return null;

    if (widthToDiv() > containerRef.current.clientWidth) {
      return true;
    }

    return false;
  };

  const validateArrowLeft = () => {
    if (widthToDiv() > scrollContainer.current?.clientWidth) {
      if (courseIndex === 0) {
        setShowLeft(false);
      }

      if (courseIndex !== 0) {
        setShowLeft(true);
      }
    } else {
      setShowLeft(false);
    }
  };

  useEffect(() => {
    const validate = validateArrowRight();
    if (validate) {
      if (tabs.length - 1 === courseIndex) {
        setshowLeftArrow(false);
      } else {
        setshowLeftArrow(validate);
      }
    } else if (width && widthToDiv() < width) {
      setshowLeftArrow(false);
    }
    validateArrowLeft();
  }, [width]);

  const onToggleTab = (id: string) => {
    GoogleAnalytics.writeLog(
      `portal-services-reinforcement${id === '' ? 'Inscriptions' : 'Courses'}`,
      'services'
    );
    toggleTab(id);
    selectIndex(tabs.findIndex((element) => element.id === id));
    validateArrowLeft();
  };

  return (
    <Titles
      className="no-scroll"
      data-testid="cmp-reinforcements-navigation"
      onScroll={handleScroll}
      ref={containerRef}
      style={{
        overflow: width && widthToDiv() > width ? 'auto' : 'hidden',
        paddingLeft: 8,
        paddingRight: 8
      }}
    >
      {showLeft && (
        <DateNavigator
          leftDate
          left="4px"
          tabs={tabs}
          courseIndex={courseIndex}
          selectIndex={selectIndex}
          toggleTab={toggleTab}
        />
      )}
      <div ref={scrollContainer} style={{ display: 'flex' }}>
        {!loadingScroll &&
          tabs.map((category: any) => {
            const order = category.id;
            return (
              <div
                key={IDHelpers.generateID()}
                className={courseIdState === order ? 'active' : ''}
                data-order={order}
              >
                <Button
                  data-testid="cmp-button-navigation-tab"
                  className={`tabs ${courseIdState === order && 'active-tabs'}`}
                  onClick={() => onToggleTab(order)}
                >
                  <p>
                    {TextHelper.capitalize(category.name)}{' '}
                    {order === '' ? ` (${subscriptions})` : ''}
                  </p>
                </Button>
              </div>
            );
          })}
      </div>
      {showLeftArrow && (
        <DateNavigator
          leftDate={false}
          right="4px"
          tabs={tabs}
          courseIndex={courseIndex}
          selectIndex={selectIndex}
          toggleTab={toggleTab}
        />
      )}
    </Titles>
  );
};

Navigation.defaultProps = {
  subscriptions: 0
};
export default Navigation;
